<template>
<v-layout class="fill-height">
  <v-container
    id="contentDashboard" fluid
    class="fill-height"
  >
    <v-layout>
      <v-row
        align="start"
        justify="start"
      >
        <v-col cols="12" class="pt-1">
          <header-sidebar></header-sidebar>
          <v-toolbar class="main-dashboard-toolbar" dense flat>
            <v-toolbar-title>
                Bonjour,<b> {{user}}</b>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-row>
            <v-col cols="12" md="8">
              <v-card class="table-content">
                <v-card-title style="background: linear-gradient(90deg, rgb(13, 74, 186) 0%, rgb(9, 155, 223) 100%);color: white;font-weight: 700;border-radius: 10px;position: relative;bottom: 5px;right: 10px; width:fit-content; min-width:50%;  box-shadow: 10px 10px 20px rgba(9,155,233,0.2);" class="px-5">Statistiques</v-card-title>
                <v-row style="width:100%; margin: 0 auto; margin-top:30px;">
                  <v-col cols="12" md="4" style="position:relative;">
                    <div class="chart">
                      <apexchart type="area" height="120" width="200" :options="chartOptions" :series="series"></apexchart>
                    </div>
                    <span class="stat-num-title">146</span>
                    <span class="stat-num-unity">dossiers</span>
                    <span class="stat-class">Import</span>
                  </v-col>
                  <v-col cols="12" md="4" style="position:relative;">
                    <div class="chart">
                      <apexchart type="area" height="120" width="200" :options="chartOptions2" :series="series"></apexchart>
                    </div>
                    <span class="stat-num-title">58</span>
                    <span class="stat-num-unity">dossiers</span>
                    <span class="stat-class">Export</span>
                  </v-col>
                  <v-col cols="12" md="4" style="position:relative;">
                    <div class="chart">
                      <apexchart type="area" height="120" width="200" :options="chartOptions3" :series="series"></apexchart>
                    </div>
                    <span class="stat-num-title">286</span>
                    <span class="stat-num-unity">dossiers</span>
                    <span class="stat-class">Total Traités</span>
                  </v-col>     
                  
                  <v-col cols="12" md="12"><v-divider></v-divider></v-col>
                  
                  <v-col cols="12" md="6" style="position:relative;">
                    <span class="stat-title">15</span>
                    <span class="stat-unity">%</span>
                    <span class="stat-text-class">Taux de progression</span>
                  </v-col>
                  <v-col cols="12" md="6" style="position:relative;">
                    <span class="stat-title">21,96</span>
                    <span class="stat-unity">Milles TND</span>
                    <span class="stat-text-class">Bénéfices</span>
                  </v-col>

                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-avatar
                class="profile"
                color="white"
                size="164"
              >
                <v-img
                    v-if="userdata.agent.picture_url"
                    :src="$baseURL + 'uploads/'+ userdata.agent.picture_url"
                ></v-img>
                <v-img
                    v-else
                    :src="profile_picture_standard"
                ></v-img>
              </v-avatar>
              <p class="mt-2 mb-0" style="font-size:24px;">{{user}}</p>
              <p class="my-0" style="font-size:15px; font-weight:700; font-family: 'Raleway', sans-serif;"><span v-if="userdata.agent">{{userdata.agent.titre_pro}}</span></p>
              <p style="color:gray; font-size:12px;">Dernière connexion le {{last_connect | formatDate }} à {{new Date(last_connect).getHours() + ':' + new Date(last_connect).getMinutes()}}</p>
              <v-card class="table-content">
                <v-card-title style="background: linear-gradient(90deg, rgb(13, 74, 186) 0%, rgb(9, 155, 223) 100%);color: white;font-weight: 700;border-radius: 10px;position: relative;bottom: 5px;right: 10px; width:fit-content; min-width:50%; box-shadow: 10px 10px 20px rgba(9,155,233,0.2);" class="px-5">Accès Rapide</v-card-title>
                <v-card-text class="pa-0">
                  <v-list-item-group v-model="item" color="primary">
                    <v-list-item>Nouveau Navire</v-list-item>
                    <v-list-item>Nouveau Port</v-list-item>
                    <v-list-item>Nouvelle Préstation</v-list-item>
                  </v-list-item-group>
                </v-card-text>
              </v-card>
            </v-col>
            
          </v-row>
          
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</v-layout>
</template>

<script>
import headerSidebar from './commons/header_sidebar.component'
import VueApexCharts from 'vue-apexcharts'
import VueJwtDecode from "vue-jwt-decode"
import profile_picture from '../../assets/profile_picture.png'
export default {
  name: 'Dashboard',
  components: {headerSidebar, apexchart:VueApexCharts},
  data: () => ({
    drawer: true,
    mini: false,
    profile_picture_standard: profile_picture,
    search: '',
    expanded: [],
    drawerClass: '',
    dialog: false,
    item: {},
    series: [{
      name: 'series2',
      data: [11, 32, 45, 32, 34, 52, 41]
    }],
    chartOptions2: {
      chart: {
        toolbar: {
          show: false
        },
        height: 200,
        type: 'area',
        offsetX: 0,
        zoom: {
          enabled: false
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      xaxis: {
        type: 'datetime',
        categories: ["2020-03-15T00:00:00.000Z", "2020-04-15T01:30:00.000Z", "2020-05-15T02:30:00.000Z", "2020-06-15T03:30:00.000Z", "2020-07-15T04:30:00.000Z", "2020-08-15T05:30:00.000Z", "2020-09-15T06:30:00.000Z"],
        labels: {
          show: false
        }
      },
      yaxis: {
        labels: {
          show: false
        }
      },
      tooltip: {
        enabled: false
      },
    },
    chartOptions: {
      colors: ['#ffc967'],
      chart: {
        toolbar: {
          show: false
        },
        height: 200,
        type: 'area',
        offsetX: 0,
        zoom: {
          enabled: false
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      xaxis: {
        type: 'datetime',
        categories: ["2020-03-15T00:00:00.000Z", "2020-04-15T01:30:00.000Z", "2020-05-15T02:30:00.000Z", "2020-06-15T03:30:00.000Z", "2020-07-15T04:30:00.000Z", "2020-08-15T05:30:00.000Z", "2020-09-15T06:30:00.000Z"],
        labels: {
          show: false
        }
      },
      yaxis: {
        labels: {
          show: false
        }
      },
      tooltip: {
        enabled: false
      },
    },
    chartOptions3: {
      colors: ['#f03735'],
      chart: {
        toolbar: {
          show: false
        },
        height: 200,
        type: 'area',
        offsetX: 0,
        zoom: {
          enabled: false
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      xaxis: {
        type: 'datetime',
        categories: ["2020-03-15T00:00:00.000Z", "2020-04-15T01:30:00.000Z", "2020-05-15T02:30:00.000Z", "2020-06-15T03:30:00.000Z", "2020-07-15T04:30:00.000Z", "2020-08-15T05:30:00.000Z", "2020-09-15T06:30:00.000Z"],
        labels: {
          show: false
        }
      },
      yaxis: {
        labels: {
          show: false
        }
      },
      tooltip: {
        enabled: false
      },
    },
    email: '',
    user: '',
    last_connect: '',
    userdata: {}
 
  }),
  async created(){
    this.userdata = Object.assign(VueJwtDecode.decode(this.$store.getters.getUser).userData, {agent: {}})
      if(this.userdata.agent_id > 0){
          await this.axios
              .get('/agent/listing')
              .then(res =>
              {
                  let agentList = res.data
                  this.userdata.agent = agentList.filter(v => { return v.id === this.userdata.agent_id } )[0]
              })
      }
  },
  mounted(){
    this.email = VueJwtDecode.decode(this.$store.getters.getUser).userData.email
    this.user = VueJwtDecode.decode(this.$store.getters.getUser).userData.username
    this.last_connect = VueJwtDecode.decode(this.$store.getters.getUser).userData.last_connect
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .chart {
    position: absolute !important;
    left: 0;
    right: 0;
    top: -35px;
    margin: 0 auto;
    z-index: 0;
    width: fit-content;
  }
  .stat-num-unity{
    display:block;
    font-family: "Raleway", sans-serif;
    font-weight:700;
    position: relative;
    z-index: 3;
    transform: rotate(90deg) translateX(-70px) translateY(-80px);
  }
  .stat-unity {
    display:inline-block;
    font-family: "Raleway", sans-serif;
    font-weight:700;
    position: relative;
    z-index: 3;
  }
  .stat-title {
    font-weight:700;
    font-family: "Raleway", sans-serif;
    font-size:82px;
    position: relative;
    z-index: 3;
  }
  .stat-text-class {
    margin: 0 auto;
    color: gray;
    display: block;
  }
  .stat-class {
    position: absolute;
    z-index: 3;
    bottom: 25px;
    margin: 0 auto;
    color: gray;
  }
  .stat-num-title{
    font-weight:700;
    font-family: "Raleway", sans-serif;
    font-size:78px;
    position: relative;
    z-index: 3;
  }
  .filter-selectbox{
    margin-left: 16px;
    width: 63%;
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 97.7%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .toggle-second-sidebar {
    float: left;
    width: 48px;
    height: 48px;
    top: 89px;
    transform: translateX(-24px);
    font-size:12px;
    background: white;
    border: 1px solid rgba(0,0,0,0.1);
    .toggle-icon {
      margin-left:15px;
    }
  }
  .main-dashboard-toolbar {
    background: transparent !important;
    padding-left: 15px;
  }
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
  .v-data-table td, .v-data-table th{
    padding: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboard/dashboard.vue